import { render } from "./GameIntro.vue?vue&type=template&id=011cacf9&scoped=true"
const script = {}

import "./GameIntro.vue?vue&type=style&index=0&id=011cacf9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-011cacf9"

export default script